import {
    GET_ZELLE_USER, GET_ZELLE_USER_RESET, LOOKUP_ZELLE_USER, LOOKUP_ZELLE_USER_RESET, SUBMIT_ZELLE_REQUEST, SUBMIT_ZELLE_REQUEST_RESET
} from '../actions/zelle';

const initialState = {
    zelleUser: null,
    getZelleUserSuccess: null,
    getZelleUserError: null,
    lookupZelleUserSuccess: null,
    lookupZelleUserError: null,
    submitZelleRequestSuccess: null,
    submitZelleRequestError: null,
    submitZelleRequestStatus: null,
    submitZelleRequestTransactionAmount: 0
};

export default function zelleReducer(state = initialState, action) {
    switch (action.type) {
        case GET_ZELLE_USER:
            return {
                ...state,
                ...(action.payload && action.payload.getZelleUserSuccess && {
                    zelleUser: action.payload.zelleUser,
                    getZelleUserSuccess: true
                }),
                getZelleUserError: action.error
            };
        case GET_ZELLE_USER_RESET:
            return {
                ...state,
                getZelleUserSuccess: initialState.getZelleUserSuccess,
                getZelleUserError: initialState.getZelleUserError,
            };
        case LOOKUP_ZELLE_USER:
            return {
                ...state,
                ...(action.payload && action.payload.lookupZelleUserSuccess && {
                    zelleUser: action.payload.zelleUser,
                    lookupZelleUserSuccess: true
                }),
                lookupZelleUserError: action.error
            };
        case LOOKUP_ZELLE_USER_RESET:
            return {
                ...state,
                lookupZelleUserSuccess: initialState.lookupZelleUserSuccess,
                lookupZelleUserError: initialState.lookupZelleUserError,
            };
        case SUBMIT_ZELLE_REQUEST:
            return {
                ...state,
                ...(action.payload && action.payload.submitZelleRequestSuccess && {
                    submitZelleRequestSuccess: true,
                    submitZelleRequestStatus: action.payload.submitZelleRequestStatus,
                    submitZelleRequestTransactionAmount: action.payload.submitZelleRequestTransactionAmount
                }),
                submitZelleRequestError: action.error
            };
        case SUBMIT_ZELLE_REQUEST_RESET:
            return {
                ...state,
                submitZelleRequestSuccess: initialState.submitZelleRequestSuccess,
                submitZelleRequestError: initialState.submitZelleRequestError,
            };
        default:
            return state;
    }
}